import { memo, useRef } from "react";
import classNames from "classnames";
import { ESIInclude } from "../../../__shared__/ESIInclude/ESIInclude";
import styles from "./SocialProofMessages.module.scss";

export const SocialProofMessages = memo(function SocialProofMessages({
  productId,
  brand,
  availableToOrder,
  appId,
  withClose = true,
  className = "",
}: {
  productId: string;
  brand: string;
  availableToOrder: boolean;
  appId: string;
  withClose?: boolean;
  className?: string;
}) {
  const url = useRef(
    `/esi/social-proof-messaging-ui/?${new URLSearchParams({
      productId,
      brand,
      appId,
      availableToOrder: availableToOrder ? "true" : "false",
      withClose: withClose ? "true" : "false",
    }).toString()}`,
  );

  return (
    productId &&
    brand &&
    appId && (
      <div
        data-testid={`social-proof-messaging-${productId}`}
        className={classNames(
          "esi-wrapper",
          styles["social-proof-messages-esi-wrapper"],
          className && styles[className],
        )}
      >
        <ESIInclude
          id={`jl-social-proof-messaging-${productId}`}
          src={url.current}
        />
      </div>
    )
  );
});
